"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "dirty": false,
    "raw": "v1.21.0-0-g6e15dc0",
    "hash": "g6e15dc0",
    "distance": 0,
    "tag": "v1.21.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.21.0",
        "major": 1,
        "minor": 21,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "1.21.0"
    },
    "suffix": "0-g6e15dc0",
    "semverString": "1.21.0"
};
//# sourceMappingURL=version.js.map